import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../assets/image/logo1.webp";
import "../assets/css/menu.css";
import { MdOutlineAttachEmail } from "react-icons/md";
import { FaHome } from "react-icons/fa";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { TbToolsKitchen3 } from "react-icons/tb";
import { IoMdContacts } from "react-icons/io";
import { BsInfoCircleFill } from "react-icons/bs";
import { FaUserCog } from "react-icons/fa"; // Importez une icône pour l'admin

export default function Header() {
    const { t, i18n } = useTranslation("header");
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const navRef = useRef(null);
    const overlayRef = useRef(null);

    const isLoginPage = location.pathname === "/Connexion";
    const isCreateAccountPage = location.pathname === "/Creer_compte";
    const isAdminPage = location.pathname === "/AdminDashboard";
    const isAdminLoggedIn = localStorage.getItem("adminToken"); // Vérifiez si le token admin existe

    const handleLanguageChange = (e) => {
        const newLanguage = e.target.value;
        i18n.changeLanguage(newLanguage);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    const handleLinkClick = (link) => {
        closeMenu();
    };

    const handleAdminLogout = () => {
        localStorage.removeItem("adminToken");
        // Redirigez l'utilisateur vers la page de connexion admin ou la page d'accueil
        window.location.href = "/Connexion"; // Assurez-vous que cette route existe
    };

    useEffect(() => {
        if (navRef.current) {
            if (isOpen) {
                navRef.current.classList.add("column-layout");
                if (overlayRef.current) {
                    overlayRef.current.style.display = "block";
                }
                document.body.style.overflow = "hidden";
            } else {
                navRef.current.classList.remove("column-layout");
                if (overlayRef.current) {
                    overlayRef.current.style.display = "none";
                }
                document.body.style.overflow = "auto";
            }
        }
    }, [isOpen]);

    const getNavLinkClass = (hash) => {
        return location.hash === hash ? "active" : "";
    };
    

    return (
        <>
            <nav ref={navRef}>
                <div className="menu-header-mobile">
                    <Link
                        to="/#accueil"
                        onClick={closeMenu}
                        className="menu-logo-mobile"
                    >
                        <img
                            src={logo}
                            alt="logo du site"
                            className="logomenu"
                        />
                    </Link>
                    <button
                        className="menu-toggle"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {isOpen ? "✕" : "☰"}
                    </button>
                </div>

                <div className={`menu-left ${isOpen ? "open" : ""}`}>
                    <Link
                        to="/#accueil"
                        className={getNavLinkClass("#accueil")}
                        onClick={closeMenu}
                    >
                        <FaHome className="icon" /> {t("home")}
                    </Link>
                    <Link
                        to="/#Apropos"
                        className={getNavLinkClass("#Apropos")}
                        onClick={closeMenu}
                    >
                        <BsInfoCircleFill className="icon" /> {t("about")}
                    </Link>
                    <Link
                        to="/#Service"
                        className={getNavLinkClass("#Service")}
                        onClick={closeMenu}
                    >
                        <TbToolsKitchen3 className="icon" /> {t("services")}
                    </Link>
                </div>
                <div className="menu-logo">
                    <Link to="/#accueil">
                        <img
                            src={logo}
                            alt="logo du site"
                            className="logomenu"
                        />
                    </Link>
                </div>
                <div className={`menu-right ${isOpen ? "open" : ""}`}>
                    <Link
                        to="/#Temoignage"
                        className={getNavLinkClass("#Temoignage")}
                        onClick={closeMenu}
                    >
                        <IoMdContacts className="icon" /> {t("testimonials")}
                    </Link>
                    <Link
                        to="/#Contact"
                        className={getNavLinkClass("#Contact")}
                        onClick={closeMenu}
                    >
                        <TfiHeadphoneAlt className="icon" /> {t("contact")}
                    </Link>
                    <Link
                        to="/Creer_compte"
                        className={getNavLinkClass("/Creer_compte")}
                        onClick={closeMenu}
                    >
                        <MdOutlineAttachEmail className="icon" /> {t("info")}
                    </Link>

                    {!isAdminLoggedIn && (
                        <Link
                            to="/Connexion"
                         className="conexionAdmin"
                            onClick={closeMenu}
                        >
                             {t("login")}
                        </Link>
                    )}
                    {/* 
                    {isAdminLoggedIn && (
                        <Link
                            to="/AdminDashboard"
                            className={getNavLinkClass("/AdminDashboard")}
                            onClick={closeMenu}
                        >
                            <FaUserCog className="icon" /> {t("admin")}{" "}
                          
                        </Link>
                    )}
                    {isAdminLoggedIn && (
                        <button
                            onClick={handleAdminLogout}
                            className="logout-button-header"
                        >
                            {t("logout")}{" "}
                          
                        </button>
                    )} */}
                    <select
                        onChange={handleLanguageChange}
                        defaultValue={i18n.language}
                        className={isOpen ? "open" : ""}
                    >
                        <option value="en">EN</option>
                        <option value="fr">FR</option>
                    </select>
                </div>
            </nav>
            <div
                ref={overlayRef}
                className="menu-overlay"
                onClick={closeMenu}
            ></div>
        </>
    );
}
